/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Col, Input, Row, Select, Form } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getListFitnessLevel, watchListFitnessLevel } from '@/redux/slices/regulate-level-physical-activity.slice';

type PhysicalActivitySliderSearcherProps = {
  onSearch: (values: FilterPhysicalActivity) => void;
};


export const RegulateLevelPhysicalActivityFilter = ({
  onSearch
}: PhysicalActivitySliderSearcherProps) => {
  const dispatch = useAppDispatch();
  const fitnessLevelList = useAppSelector(watchListFitnessLevel);
  const [form] = Form.useForm();

  const fitnessLevelOptions = useMemo(
    () => [
      { value: '', label: 'Tất cả' },
      ...fitnessLevelList.map((fitnessLevel) => ({
        value: fitnessLevel.id,
        label: fitnessLevel.name
      }))
    ],
    [fitnessLevelList]
  );

  useEffect(() => {
    dispatch(getListFitnessLevel());
  }, [dispatch]);

  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  const handleReset = () => {
    form.resetFields();
    form.setFieldsValue({ idOptions: '' });
    onSearch({});
  };

  return (
    <Form form={form}>
      <Row gutter={16} align="middle">
        <Col span={8} css={filterItem}>
          <Form.Item label="Mức độ hoạt động thể lực" name="idOptions" css={customLabel}>
            <Select placeholder="Tất cả" options={fitnessLevelOptions} style={{ width: "16rem" }} />
          </Form.Item>
        </Col>
        <Col span={8} css={filterItem} style={{ marginLeft: "30px"}}>
          <Form.Item label="Độ tuổi" css={customLabel}>
            <Row gutter={8} align="middle">
              <Col span={11}>
                <Form.Item name="ageMin"
                  style={{ marginBottom: 0 }}>
                  <Input placeholder="Nhập tuổi" />
                </Form.Item>
              </Col>
              <Col span={3} style={{ textAlign: "center" }}>đến</Col>
              <Col span={10}>
                <Form.Item name="ageMax" style={{ marginBottom: 0 }}>
                  <Input placeholder="Nhập tuổi" />
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
        </Col>
        <Col span={7} css={filterSearchItem} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Button
          type="default"
          icon={<ReloadOutlined />}
          css={resetButton}
          onClick={handleReset}>
            Đặt lại
          </Button>
          <Button
          type="primary"
          icon={<SearchOutlined/>} 
          css={searchButton}
          onClick={handleSearch}>
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </Form>
  );  
};

const filterItem = css`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  label {
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    min-width: 6rem;
    word-wrap: break-word;
    word-break: break-word;
  }

  input, .ant-select, .ant-picker {
    flex: 1;
  }
`;

const filterSearchItem = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  label {
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    min-width: 6rem;
    word-wrap: break-word;
    word-break: break-word;
  }

  input, .ant-select, .ant-picker {
    flex: 1;
  }
`;

const resetButton = css`
  margin-right: 10px;
  color: #007bff;
  border-color: #007bff;
`;

const searchButton = css`
  background: #007bff;
  color: white;
  &:hover {
    background: #0056b3;
  }
`;

const customLabel = css`
  .ant-form-item-label > label {
    font-weight: normal !important;
  }
  margin-bottom: 0;
`;